import React, {useContext, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {AvailabilityPane} from 'components/AvailabilityCalendarPane'
import {HotelCardContext} from 'components/HotelCardContext'
import {
  getHotelAvailabilityPrices,
  getHotelAvailabilityPricesComplete,
  getSearchParameters
} from 'modules/sapiSearch/selectors'

import {cssTheme} from '@vio/atlas/themes'
import {
  getDatesToDisplay,
  MAX_DATES_TO_SHOW_DESKTOP
} from '@vio/core/src/_web/availability'

import {Loading} from './Loading'

interface Props {
  sourceComponentPrefix: string
}

const AvailabilityPaneWrapper = styled.div`
  grid-column: 2 / 4;
  grid-row: 2 / 3;
  margin-left: ${cssTheme.layout.spacing.s500};
  padding-top: ${cssTheme.layout.spacing.s300};
`

export const UnavailabilityDesktop = ({sourceComponentPrefix}: Props) => {
  const {hotelId} = useContext(HotelCardContext)
  const {checkIn} = useSelector(getSearchParameters)
  const hotelAvailabilityPrices = useSelector(state =>
    getHotelAvailabilityPrices(state, hotelId)
  )
  const datesToDisplay =
    hotelAvailabilityPrices &&
    getDatesToDisplay(
      hotelAvailabilityPrices,
      checkIn,
      MAX_DATES_TO_SHOW_DESKTOP
    )

  const availabilitySearchComplete = useSelector(
    getHotelAvailabilityPricesComplete
  )

  const [initialSearchComplete, setInitialSearchComplete] =
    useState<boolean>(false)

  useEffect(() => {
    if (availabilitySearchComplete) {
      // Preserve initial search complete state to avoid showing the `loading` state when more data is being fetched
      setInitialSearchComplete(true)
    }
  }, [availabilitySearchComplete])

  return initialSearchComplete ? (
    datesToDisplay && (
      <AvailabilityPaneWrapper>
        <AvailabilityPane
          hotelId={hotelId}
          sourceComponentPrefix={sourceComponentPrefix}
          hotelAvailabilityPrices={hotelAvailabilityPrices}
          datesToDisplay={datesToDisplay}
          availabilitySearchComplete={availabilitySearchComplete}
        />
      </AvailabilityPaneWrapper>
    )
  ) : (
    <AvailabilityPaneWrapper>
      <Loading />
    </AvailabilityPaneWrapper>
  )
}
